import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { utils } from '@desygner/ui-common-components';
import { capitalizeFirstLetter } from 'src/utils/string';
import PropTypes from 'prop-types';

const getSize = ({ size, theme }) => utils.rem(theme.Icon.Size[capitalizeFirstLetter(size || 'small')]);

const StyledIcon = styled.i`
  display: inline-block;
  width: ${getSize};
  height: ${getSize};
  font-weight: normal;
  font-size: ${getSize};
  line-height: ${getSize};
  color: inherit;
  vertical-align: middle;
  text-align: center;
`;
const StyledSvg = styled.svg`
  display: inline-block;
  width: ${getSize};
  height: ${getSize};
  font-weight: normal;
  font-size: ${getSize};
  line-height: ${getSize};
  color: inherit;
  vertical-align: top;
  text-align: center;

  ${props => props.angle && css`
    transform: rotate(${props.angle}deg);
  `}

  ${props => props.color && css`
    color: ${props.color};
    fill: ${props.color};
  `}
`;

const Svg = ({ icon, ...props }) => (
  <StyledSvg {...props} className={`icon-${icon}`}>
    <use xlinkHref={`#${icon}`} />
  </StyledSvg>
);

Svg.propTypes = {
  icon: PropTypes.string.isRequired
};

function Icon ({
  name,
  size = 'small',
  title,
  angle,
  color
}) {
  return <StyledIcon title={title}>
    <Svg
      angle={angle}
      icon={name}
      size={size}
      color={color}
    />
  </StyledIcon>;
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'large']),
  title: PropTypes.string,
  angle: PropTypes.number,
  color: PropTypes.string
};

export default memo(Icon);
